import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const enumSortDialogStyle: StyleRulesCallback = () => {
  return {
    paperWidthMd: {
      width: '500px',
    },
  };
};

export default enumSortDialogStyle;
